import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { GQLExtension } from '../web-client/graphql/types';

// Preserve the legacy layout classification until the layout switch is enabled.
export const isBodiedLayout = (layout: unknown): boolean =>
	layout === 'bodied' ||
	(layout === 'inline-bodied' && fg('platform_forge_inline_bodied_layout_switch'));

export const getExtensionType = (
	extension: Pick<GQLExtension, 'properties'>,
): 'extension' | 'inlineExtension' | 'bodiedExtension' => {
	const { properties } = extension;

	if (isBodiedLayout(properties?.layout)) {
		return 'bodiedExtension';
	} else if (properties?.layout === 'inline') {
		return 'inlineExtension';
	}
	return 'extension';
};
